<template>
  <div class="container">
    <img class="succeed_icon" src="../../../assets/ic_succeed@2x.png" />
    <h1 class="title">报名成功</h1>
    <div class="hint">优学派工作人员收到您的报名信息后会尽快与您联系，请注意来电接听</div>
    <van-button @click="onBack" class="submit" color="#445179" type="primary"
      >返回活动页面</van-button
    >
  </div>
</template>
<script>
import { PAGE_EXPOSE, BUTTON_CLICK } from "../../../utils/bigDataSdk";

const pageInfo = {
  pageId: "40003",
  pageName: "报名成功页",
  pageTilte: "报名成功",
};
export default {
  props: {
    tracker: Function,
  },
  mounted() {
    setTimeout(() => {
      this.tracker({
        eventKey: PAGE_EXPOSE,
        ...pageInfo,
      });
    }, 0);
  },
  methods: {
    onBack() {
      const { activity_url, back_url } = this.$route.query || {};
      this.tracker({
        eventKey: BUTTON_CLICK,
        ...pageInfo,
        buttonName: "返回活动页面",
        buttonContent: "返回活动页面",
      });
      if (activity_url && !back_url) {
        location.href = activity_url
      }
      // 返回小程序的活动页
      else if (wx && wx.miniProgram && back_url) {
        console.log('wx')
        wx.miniProgram.navigateBack();
        // 返回活动页
      }  else {
        history.back();
      }
      
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.succeed_icon {
  margin-top: 59px;
  width: 144px;
  height: 126px;
}
.title {
  margin-top: 50px;
  font-size: 24px;
  font-weight: bold;
  color: #34404a;
}
.hint {
  margin-top: 24px;
  font-size: 16px;
  color: #888888;
  font-weight: 500;
  text-align: center;
  width: 303px;
}
.submit {
  margin-top: 45px;
  width: 305px;
}
</style>
